import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}`;

export const fraudDetectionTools = {
  getData,
};

function getData(platform,handle) {
  return fetchWrapper.get(`${baseUrl}/ds-analytics/${platform}/${handle}`);
}

